// Mirrors OTP_ENABLED in the backend (routes/authRouter.js).
//
// While this is false the backend creates accounts pre-verified, accepts the
// account-verification endpoints without a code, and refuses password reset
// with a 503 because it has no channel to deliver a code on. The frontend must
// therefore skip the OTP screens entirely rather than send users to a form that
// cannot succeed.
//
// Set REACT_APP_OTP_ENABLED=true (and OTP_ENABLED=true on the backend) to turn
// email verification back on. Both sides default to off when the var is unset.
export const OTP_ENABLED = process.env.REACT_APP_OTP_ENABLED === "true";
